const state = {
    truckTrackingData : null,
    monitoringSjData: null,
}

const getters = {
    currentTruckTrackingData : state => {
        return state.truckTrackingData
    },
    currentMonitoringSjData : state => {
        return state.monitoringSjData
    }
}

const mutations = {
    truckTrackingDataStatus (state, truckTracking){
        if(truckTracking){
            state.truckTrackingData = truckTracking;
        } else {
            state.truckTrackingData = null;
        }
    },
    monitoringSjDataStatus (state, truckTracking) {
        if (truckTracking) {
            state.monitoringSjData = truckTracking;
        } else {
            state.monitoringSjData = null;
        }
    }
}

const actions = {
    setTruckTrackingData ({ commit }, truckTracking){
        commit('truckTrackingDataStatus', truckTracking);
    },
    setMonitoringSjData ({ commit }, truckTracking) {
        commit('monitoringSjDataStatus', truckTracking);
    }
}

export default{
    state,
    getters,
    mutations,
    actions
}